import { Navigate, Outlet } from "react-router-dom";
import { SuperAdminTypeId } from "../../shared/constants/Resources";
import { WebRoutes } from "../../shared/constants/WebRoutes";
import {
  selectCurrentAdminToken,
  selectCurrentAdminType,
} from "./selectorHelper";
import { HandleLoginHelper } from "./verifyLoginHelper";

const StrictSuperAdminAuth = () => {
  const token = selectCurrentAdminToken();
  const isAuthenticated = Boolean(token && HandleLoginHelper(token));
  const isSuperAdmin = selectCurrentAdminType() === SuperAdminTypeId;

  return isAuthenticated && isSuperAdmin ? (
    <Outlet />
  ) : (
    <Navigate to={WebRoutes.TripTableRoute} replace />
  );
};

export default StrictSuperAdminAuth;
